import { Link } from 'react-router-dom';
import { Home, Hexagon } from 'lucide-react';

export function NotFoundPage() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] p-6 text-center">
      <Hexagon className="w-16 h-16 text-dim mb-6" strokeWidth={0.8} />
      <h1 className="font-display font-black text-6xl gradient-text mb-3">404</h1>
      <p className="font-display font-semibold text-lg mb-1">Page not found</p>
      <p className="text-muted mb-8 font-body text-sm">
        The page you're looking for doesn't exist or has been moved.
      </p>
      <Link to="/" className="btn btn-primary flex items-center gap-2">
        <Home className="w-4 h-4" />
        Go Home
      </Link>
    </div>
  );
}
